import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import withUser from '../HOC/HOCwithUser.jsx';
import { connect } from 'react-redux';
import { compose } from 'redux';
import * as actions from '../../actions';
import {
    List,
    ListItem,
    ListItemAvatar,
    Button,
    ListItemSecondaryAction,
    ListItemText,
    Paper,
    TextField,
    Dialog,
    Fade,
    MenuItem,
    CircularProgress
} from '@material-ui/core';
import ProgressiveImage from 'react-progressive-image';
import ContentLoader from 'react-content-loader';
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment';
import { FacebookShareButton, FacebookIcon, TwitterIcon, EmailIcon, TwitterShareButton, EmailShareButton } from 'react-share';
import { Share } from '@material-ui/icons';
import axios from 'axios';
import { getCookies } from '../../utils/getToken.js';
import { SERVER_URL } from '../../utils/config/constants.js';
import DateTimePanel from '../Booking/DateTimePanel.jsx';
import Dropzone from 'react-dropzone';
import { NotificationManager } from 'react-notifications';
import StarRatings from 'react-star-ratings';

const styles = theme => ({
    root: {
        width: '100%'
    },
    inline: {
        display: 'inline'
    },
    margin: {
        margin: theme.spacing.unit
    },
    extendedIcon: {
        marginRight: theme.spacing.unit
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        marginBottom: '10px'
    }
});

var formData = new FormData()

const handleDropRejected = (...args) =>
    NotificationManager.error(
        <FormattedMessage
            id="errorUploading"
            defaultMessage="Unable to upload this picture, try another"
        />,
        'Error'
    );
class ReviewList extends React.Component {
    constructor() {
        super();
        this.handleDrop = this.handleDrop.bind(this);
    }
    state = {
        mainData: [],
        category: "",
        notes: "",
        isImage: false,
        openDateTime: false,
        dateTimeValue: "",
        imageFiles: [],
        loader: true


    }
    componentDidMount() {
        this.getMainLog();
    }
    getMainLog = () => {
        var authToken = getCookies();
        axios({
            method: 'get',
            url: `${SERVER_URL}/rating/average`,
            headers: {
                'x-auth-Token': authToken
            }
        }).then((resJson) => {
            console.log("Resjsonnnn:::", resJson)
            if (resJson.data.status == "OK") {
                this.setState({
                    mainData: resJson.data.data.latest_reviews,
                    loader: false
                })
            } else {
                this.setState({
                    mainData: [],
                    loader: false,
                })
            }
        })
    }

    onChangeDate = event => {
        console.log("date event::::::::", event)
        const dateTimeValue = moment(event).format('MM-DD-YYYY');
        this.setState({ openDateTime: true, dateTimeValue: dateTimeValue, openDateTime: false });
    };


    handleDrop(files) {
        this.setState({
            isImage: true,
            imageFiles: this.state.imageFiles.concat(files.map(file =>
                Object.assign(file, {
                    preview: URL.createObjectURL(file),
                })))
        })
    }

    render() {

        var max = moment().add(0, 'day')

        var valid = function (current) {
            return (max >= current);
        };

        if (this.state.loader) {
            return (
                <div style={{ minHeight: '800px' }}>
                    <div className={'loader-view loader-center'}>
                        <CircularProgress color="primary" />
                    </div>
                </div>)
        }

        return (
            <div className="md-12" style={{ width: "100%" }}>

                <div className="md-12">
                    {this.state.mainData.length > 0 && this.state.mainData.map((item) => {
                        return (
                            <Paper className="m-2 p-2 ">
                                <div className="md-12 row">
                                    <div className="d-flex col-md-4" style={{ height: 30, alignItems: "center" }} ><p><b>Date:</b></p></div>
                                    <div className="d-flex col-md-8 " style={{ height: 30, alignItems: "center" }}><p>{moment(item.created_at).format('MM-DD-YYYY')}</p></div>
                                </div>
                                <div className="md-12 row mt-2">
                                    <div className="d-flex col-md-4" style={{ height: 30, alignItems: "center" }}><p><b>Name:</b></p></div>
                                    <div className="d-flex col-md-8" style={{ height: 30, alignItems: "center" }}><p>{item.origin.name}</p></div>
                                </div>

                                <div className="md-12 row mt-2">
                                    <div className="d-flex col-md-4" style={{ height: 30, alignItems: "center" }}><p><b>Rating:</b></p></div>
                                    <StarRatings
                                        rating={item.ar}
                                        starDimension="30px"
                                        starSpacing="15px"
                                        starRatedColor={this.props.starRatedColor}
                                    />
                                </div>

                                <div className="md-12 row mt-2">
                                    <div className="d-flex col-md-4" style={{ height: 30, alignItems: "center" }}><p><b>Review:</b></p></div>
                                    <div className="d-flex col-md-8" style={{ height: 30, alignItems: "center" }}><p>{item.review}</p></div>
                                </div>

                            </Paper>
                        )
                    })
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ settings, auth }) => {
    return {
        settings: settings,
        userData: auth.userData
    };
};
const composedComponent = compose(
    withStyles(styles),
    connect(mapStateToProps, actions)
);

export default composedComponent(ReviewList);



// WEBPACK FOOTER //
// ./src/components/Customer/ReviewList.jsx